import React from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, Tooltip } from '@mui/material'

import { MoreVert } from '@mui/icons-material'
import { IconButtonBg } from '@/theme/icon-button.theme'
import { colors } from '@/theme/colors.theme'

type Props = {
  setAnchorEl?: React.Dispatch<React.SetStateAction<HTMLElement | null>>
  button?: JSX.Element
}

export const TableMenuButtonComponent = ({ setAnchorEl, button }: Props) => {
  const { t } = useTranslation()

  return (
    <TableCell
      align="center"
      sx={{
        position: 'sticky',
        right: 0,
        width: 50,
        background: colors.paper2,
      }}
    >
      {button ? (
        <>{button}</>
      ) : (
        setAnchorEl && (
          <Tooltip arrow title={`${t('labels.options')}`}>
            <IconButtonBg
              sx={{ borderRadius: '6px' }}
              size="small"
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <MoreVert fontSize="inherit" />
            </IconButtonBg>
          </Tooltip>
        )
      )}
    </TableCell>
  )
}
